// Role type placeholder, at the moment we're not going to use
// multiple roles. Retrieving policy is not required Role as param,
// since it will be passed with User Token
export const SUPER_ADMIN = "super-admin";
export const ADMIN = "admin";
export const ADMIN_RO = "admin-ro";

export type Role = typeof ADMIN | typeof ADMIN_RO | typeof SUPER_ADMIN;

export const SYSTEM = "system";
export const MSP = "msp";
export const CUSTOMER = "customer";

export type Level = typeof SYSTEM | typeof MSP | typeof CUSTOMER;

export const READ = "read";
export const WRITE = "write";

export type Action = typeof READ | typeof WRITE;

export const ACCOUNTS = "accounts";
export const ADMINISTRATORS = "administrators";
export const NOTIFICATIONS = "notifications";
export const USER_PROFILE = "user-profile";
export const EMAIL_SECURITY = "email-security";
export const PHISHING_CAMPAIGNS = "phishing-campaigns";
export const SAT_CAMPAIGNS = "sat-campaigns";
export const EMAIL_ARCHIVING = "email-archiving";
export const M365 = "m365";

export type Resource =
  | typeof ACCOUNTS
  | typeof ADMINISTRATORS
  | typeof NOTIFICATIONS
  | typeof USER_PROFILE
  | typeof EMAIL_SECURITY
  | typeof PHISHING_CAMPAIGNS
  | typeof SAT_CAMPAIGNS
  | typeof EMAIL_ARCHIVING
  | typeof M365;

export type Permission = {
  feature: Resource;
  actions: Action[];
};

export type Policy = {
  name: Role;
  permissions: Permission[];
};
